export default "__VITE_ASSET__BjgBGE2O__"